function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Modal.prototype.render = function render() {
    var _props = this.props,
        title = _props.title,
        text = _props.text,
        active = _props.active,
        children = _props.children,
        className = _props.className;
    return React.createElement("div", {
      className: "modal modal--style-default modal--type-recording-done " + (active ? "is-active" : null) + " " + className
    }, React.createElement("div", {
      className: "modal__window"
    }, React.createElement("div", {
      className: "modal__title"
    }, title), text && React.createElement("div", {
      className: "modal__text"
    }, text), children));
  };

  return Modal;
}(React.Component);

Modal.propTypes = process.env.NODE_ENV !== "production" ? {
  active: PropTypes.bool,
  title: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.any
} : {};
export default Modal;